import { render, staticRenderFns } from "./EffectTypeAdd.vue?vue&type=template&id=40425f8c&scoped=true&"
import script from "./EffectTypeAdd.vue?vue&type=script&lang=js&"
export * from "./EffectTypeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40425f8c",
  null
  
)

export default component.exports